// src/hooks/internal/useOutletRenderer.ts
import { useMemo } from "react";
import { useOutlets } from "../../context/NovuUIContext.js";
import { useDataRef } from "./useDataRef.js";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect.js";
function useOutletRenderer(renderProp) {
  const outlets = useOutlets();
  const latest = useDataRef(renderProp);
  const hasRenderer = !!renderProp;
  useIsomorphicLayoutEffect(() => {
    if (hasRenderer) {
      outlets.invalidate();
    }
  }, [outlets, hasRenderer, renderProp]);
  return useMemo(() => {
    if (!hasRenderer) {
      return void 0;
    }
    return (el, ...args) => outlets.mount(el, (...renderArgs) => latest.current?.(...renderArgs), args);
  }, [latest, outlets, hasRenderer]);
}
export {
  useOutletRenderer
};
//# sourceMappingURL=useOutletRenderer.js.map